export default "/images/2a7a5c1d9ef93a1b715252b85965fe2b.png";